export const PlaybackRate = {
  DEFAULT: 1,
  FAST: 1.5,
  FASTEST: 2
}
